import React from "react";
import moment from "moment";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import SuccessModal from "./components/SuccessModal";
import classnames from "classnames";
import shortid from "shortid";
import "./index.css";
import NewOffer from "../../components/NewOffer";
import { TerritoryOptions } from "../../Constants/retailer";
import schedule_icon from "../../assets/media/token_earning/wall-clock.png";
class BrandOffers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offers: [],
      retailers: [],
      tab: 0,
    };
  }

  async componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        this.setState(
          {
            logo: brand_data.logo,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            territory: brand_data.territory || TerritoryOptions[0],
            hex: brand_data.hex,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
          },
          () => {
            Firebase.getAllRetailers(this.subscribeRetailers);
            Firebase.getAllBrandOffers(brand_data.name, this.subscribeOffers);
          }
        );
      });
    }
  }

  subscribeOffers = (offers) => {
    this.setState({ offers, loading: false });
  };

  subscribeRetailers = (retailers) => {
    this.setState({
      retailers: Object.values(retailers).filter(
        (obj) => (obj.territory || TerritoryOptions[0]) === this.state.territory
      ),
    });
  };

  post = async (data) => {
    const { retailer, attentionGrabber, postNow, scheduledDate, hot_topic } =
      data;
    const { brand_name } = this.state;

    const offer = {
      id: shortid.generate(),
      hot_topic: hot_topic,
      retailer: retailer.value,
      attentionGrabber,
      created_at: moment().valueOf(),
      postNow,
      scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
    };
    console.log("offer", offer);
    let res = await Firebase.addBrandOffer(brand_name, offer);

    document.getElementById("success_btn").click();

    if (!postNow) {
      let schedule_data = {
        id: res.id,
        type: "offer",
        time: scheduledDate.valueOf(),
        brand_name: brand_name,
      };
      let schedule_res = await Firebase.registerSchedule(schedule_data);
      console.log("schedule_res", schedule_res);
    }
  };

  onTabChanged = (tab) => () => {
    this.setState({ tab });
  };

  onClosePoll = (index) => () => {
    const { brand } = this.state;
    const polls = [...this.state.poll_data];
    polls[index].closed = true;
    Firebase.updateBrandDataById(brand, { polls });
  };

  getNumberOfVotes = (poll) => {
    if (
      poll.isDemo &&
      poll.question ===
        "Demo Poll - Where would you like to go on Holiday to next?"
    ) {
      return 38;
    }
    const { users } = this.state;

    return users.filter(
      (user) =>
        !!(user.poll_answers || []).find((answer) => answer.poll_id === poll.id)
    ).length;
  };

  getAnswersChat = (poll) => {
    if (
      poll.isDemo &&
      poll.question ===
        "Demo Poll - Where would you like to go on Holiday to next?"
    ) {
      const answers = [...poll.answers];
      answers[0].count = 22;
      answers[1].count = 2;
      answers[2].count = 4;
      answers[3].count = 10;
      return answers;
    }
    const { users } = this.state;
    const answers = poll.answers.map((answer) => ({
      ...answer,
      count: 0,
    }));
    const filteredUsers = users.filter(
      (user) =>
        !!(user.poll_answers || []).find((answer) => answer.poll_id === poll.id)
    );

    filteredUsers.forEach((user) => {
      const answer = (user.poll_answers || []).find(
        (answer) => answer.poll_id === poll.id
      );
      if (answer) {
        answers[answer.answer_id].count += 1;
      }
    });

    // console.log('/// -- answers', answers);

    return answers;
  };
  getStatusText = (offer) => {
    if (offer.postNow) return "Live";
    else return "Pending";
  };
  renderOffers = () => {
    const { offers } = this.state;

    return (
      <div className="brand-offers-items">
        {offers.map((offer, index) => (
          <div className="brand-offer-item-container" key={index}>
            <div className="brand-offer-details">
              <p className="submitted-date">
                {offer.postNow === false ? (
                  <p>
                    <img
                      src={schedule_icon}
                      width="20"
                      height="20"
                      style={{ marginRight: 10 }}
                    />
                    Offer scheduled on{" "}
                    {moment(offer.scheduledDate).format("LLL")}
                  </p>
                ) : (
                  "Offer submitted on " +
                  moment(offer.scheduledDate).format("LLL")
                )}
              </p>
              <p className="retailer">Retailer Name: {offer.retailer}</p>
              <p className="attention">
                Attention Grabber: {offer.attentionGrabber}
              </p>
              <p className={`status-text ${this.getStatusText(offer)}`}>
                {this.getStatusText(offer)}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { logo, brand, is_property_brand, tab, loading, brand_name } =
      this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <div id="brand-offers-container">
          {loading && (
            <div className="brand-offers-loading-bar">
              <i class="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && (
            <React.Fragment>
              <div className="toggle-btn-group">
                <div
                  className={classnames("mode-toggle-btn", {
                    selected: tab === 0,
                  })}
                  onClick={this.onTabChanged(0)}
                >
                  New Offer Listing
                </div>
                <div
                  className={classnames("mode-toggle-btn", {
                    selected: tab === 1,
                  })}
                  onClick={this.onTabChanged(1)}
                >
                  Offers
                </div>
              </div>
              {tab === 0 && (
                <NewOffer
                  retailers={this.state.retailers}
                  onAdd={this.post}
                  brand_name={brand_name}
                />
              )}
              {tab === 1 && this.renderOffers()}
            </React.Fragment>
          )}
        </div>
        <button
          id="success_btn"
          type="button"
          data-toggle="modal"
          data-target="#success"
          style={{ display: "none" }}
        />
        <SuccessModal />
      </div>
    );
  }
}
export default BrandOffers;



// WEBPACK FOOTER //
// ./src/screens/BrandOffers/index.js